import { createSlice } from '@reduxjs/toolkit'
import { Dispatch } from 'redux'
import { AlertGroup, AlertTemplate } from '../../types/Alerts'
import { getRuuviTagAlertRules, getRuuviTagAlertTemplates } from '../../services/ruuviTagService'
import { AxiosRequestConfig } from 'axios'

type RuuviTagSliceState = {
  alertTemplates: AlertTemplate[]
  alertRules: AlertGroup[]
  loading: boolean
  error?: unknown
}

type SetAlertTemplatesAction = {
  type: string
  payload: AlertTemplate[]
}

type SetAlertRulesAction = {
  type: string
  payload: AlertGroup[]
}

type SetLoadingAction = {
  type: string
  payload: boolean
}

type SetErrorAction = {
  type: string
  payload: unknown | undefined
}

const initialState: RuuviTagSliceState = {
  alertTemplates: [],
  alertRules: [],
  loading: false
}

const ruuviTagSlice = createSlice({
  name: 'ruuviTag',
  initialState,
  reducers: {
    setAlertTemplates(state, action: SetAlertTemplatesAction) {
      state.alertTemplates = action.payload
    },
    setAlertRules(state, action: SetAlertRulesAction) {
      state.alertRules = action.payload
    },
    setLoading(state, action: SetLoadingAction) {
      state.loading = action.payload
    },
    setError(state, action: SetErrorAction) {
      state.error = action.payload
    }
  }
})

export const { setAlertTemplates, setAlertRules, setLoading, setError } = ruuviTagSlice.actions

export function loadRuuviTagAlertTemplates(config?: AxiosRequestConfig) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true))
      const templates = await getRuuviTagAlertTemplates(config)
      dispatch(setAlertTemplates(templates))
    } catch (error) {
      dispatch(setError(error))
    } finally {
      dispatch(setLoading(false))
    }
  }
}

export function loadRuuviTagAlertRules(id: string, config?: AxiosRequestConfig) {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true))
      dispatch(setAlertRules(await getRuuviTagAlertRules(id, config)))
    } catch (error) {
      dispatch(setError(error))
    } finally {
      dispatch(setLoading(false))
    }
  }
}

export default ruuviTagSlice.reducer
